// extracted by mini-css-extract-plugin
export default {"icon":"l6L1Fh","iconWrapper":"bFiLuu"};